module.exports = __webpack_public_path__ + "img/ring_skip_0_1_0@2x.38349b2d.png";